/* eslint-disable no-redeclare */
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import RemoveIcon from "@mui/icons-material/Remove";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Box, Button, IconButton, Modal } from "@mui/material";
import Decimal from "decimal.js";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TextInput from "../../../../components/inputs/textInput";
import { divideAndDisplay } from "../../../../scripts/functions";
import CurrencyModal from "./currencyModal";
import CurrencyModalPreview from "./currencyModalPreview";
import GoldModal from "./goldModal";
import GoldReview from "./goldReview";

const ProductCart = ({
  data,
  setData,
  currencyOption,
  type,
  defaults,
  noEdit = false,
}) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const location = useLocation();
  const [changedData, setChangedData] = useState({});
  const [calcData, setCalcData] = useState();
  const [hojrat, setHojrat] = useState(
    localStorage.getItem("hojrat") ? Number(localStorage.getItem("hojrat")) : 5
  );
  const [profit, setProfit] = useState(
    localStorage.getItem("profit") ? Number(localStorage.getItem("profit")) : 7
  );
  useEffect(() => {
    setChangedData(data);
  }, [data]);
  useEffect(() => {
    setOpen(location.hash === `#${data?.guidRecNo}`);
    setOpen2(location.hash === `#D_${data?.guidRecNo}`);
  }, [location.hash]);
  const { id } = useParams();
  const CalcPrice = () => {
    if (type === "CurrSale") {
      var prices = data.flCurrencyAmount * data.moCurrencyExchangePrice;
      var pricesAfterDiscount = prices - data?.moDiscount;
      var pricesAfteAddes = data?.flValueAddedPercent
        ? (pricesAfterDiscount * data?.flValueAddedPercent) / 100
        : 0;
      pricesAfterDiscount = pricesAfterDiscount + pricesAfteAddes;
      setCalcData(pricesAfterDiscount);
    } else {
      var prices = data.flAmount * data.moUnitPrice;
      var pricesAfterDiscount = prices - data?.moDiscount;
      var pricesAfteAddes = data?.flValueAddedPercent
        ? (pricesAfterDiscount * data?.flValueAddedPercent) / 100
        : 0;
      pricesAfterDiscount = pricesAfterDiscount + pricesAfteAddes;
      setCalcData(pricesAfterDiscount);
    }
  };
  useEffect(() => {
    CalcPrice();
  }, [data]);
  const updateHojrat = (
    amount,
    price,
    hojratValue,
    profitValue,
    name,
    value
  ) => {
    const p1 = Number(amount) * Number(price);
    const p2 = (p1 * hojratValue) / 100;

    const p4 = (p1 * profitValue) / 100;
    setData({
      ...changedData,
      moConstructionPrice: divideAndDisplay(p2),
      moProfitPrice: divideAndDisplay(p4),
      [name]: value,
    });
  };

  const handleAddOne = () => {
    const nm = new Decimal(data.flAmount).add(1).toNumber();
    updateHojrat(nm, changedData.moUnitPrice, hojrat, profit, "flAmount", nm);
  };
  const handlSubOne = () => {
    const nm = new Decimal(data.flAmount).minus(1).toNumber();
    updateHojrat(nm, changedData.moUnitPrice, hojrat, profit, "flAmount", nm);
  };
  return (
    <div className="flex flex-col gap-4">
      {!noEdit && (
        <div className="flex justify-between items-center ">
          <>
            {" "}
            {type === "CurrSale" ? (
              <>
                {" "}
                {data?.flCurrencyAmount ? (
                  <div className="flex items-center gap-2">
                    <IconButton
                      sx={{
                        border: "1px solid #ccc !important",
                        padding: "2px !important",
                        svg: { fontSize: "1.1rem !important" },
                      }}
                      onClick={() => {
                        setData({
                          ...data,
                          flCurrencyAmount: new Decimal(data.flCurrencyAmount)
                            .add(1)
                            .toNumber(),
                        });
                      }}
                    >
                      <AddIcon />
                    </IconButton>
                    <span>{data?.flCurrencyAmount}</span>
                    <IconButton
                      sx={{
                        border: "1px solid #ccc !important",
                        padding: "2px !important",
                        svg: { fontSize: "1.1rem !important" },
                      }}
                      disabled={data?.flCurrencyAmount < 1}
                      onClick={() =>
                        setData({
                          ...data,
                          flCurrencyAmount: new Decimal(data.flCurrencyAmount)
                            .minus(1)
                            .toNumber(),
                        })
                      }
                    >
                      <RemoveIcon />
                    </IconButton>
                  </div>
                ) : (
                  <Button
                    onClick={() => setData({ ...data, flCurrencyAmount: 1 })}
                    variant="contained"
                    color="primary"
                  >
                    افزودن
                  </Button>
                )}
              </>
            ) : (
              <>
                {" "}
                {data?.flAmount ? (
                  <div className="flex items-center gap-2">
                    <IconButton
                      sx={{
                        border: "1px solid #ccc !important",
                        padding: "2px !important",
                        svg: { fontSize: "1.1rem !important" },
                      }}
                      onClick={() => handleAddOne()}
                    >
                      <AddIcon />
                    </IconButton>
                    <span>{data?.flAmount}</span>
                    <IconButton
                      sx={{
                        border: "1px solid #ccc !important",
                        padding: "2px !important",
                        svg: { fontSize: "1.1rem !important" },
                      }}
                      disabled={data?.flAmount < 1}
                      onClick={() => handlSubOne()}
                    >
                      <RemoveIcon />
                    </IconButton>
                  </div>
                ) : (
                  <Button
                    onClick={() => setData({ ...data, flAmount: 1 })}
                    variant="contained"
                    color="primary"
                  >
                    افزودن
                  </Button>
                )}
              </>
            )}
          </>

          <div className="flex justify-end ">
            {data?.flCurrencyAmount || data?.flAmount ? (
              <>
                {" "}
                <IconButton
                  onClick={() => {
                    if (id) {
                      navigate(
                        `/sell/${noEdit ? "preview" : "invoice"}/${id}#${
                          data?.guidRecNo
                        }`
                      );
                    } else {
                      navigate(
                        `/sell/${noEdit ? "preview" : "invoice"}/create#${
                          data?.guidRecNo
                        }`
                      );
                    }
                  }}
                >
                  <EditIcon color="warning" />
                </IconButton>
              </>
            ) : (
              <></>
            )}

            <IconButton
              onClick={() => {
                if (id) {
                  navigate(
                    `/sell/${noEdit ? "preview" : "invoice"}/${id}#D_${
                      data?.guidRecNo
                    }`
                  );
                } else {
                  navigate(
                    `/sell/${noEdit ? "preview" : "invoice"}/create#D_${
                      data?.guidRecNo
                    }`
                  );
                }
              }}
            >
              <RemoveRedEyeIcon color="primary" />
            </IconButton>
          </div>
        </div>
      )}
      {noEdit ? (
        <div className="flex justify-between items-center">
          <span className="text-sm font-bold">
            {data?.chSellerStuffSendName
              ? data?.chSellerStuffSendName
              : data?.chSellerStuffTitle
              ? data?.chSellerStuffTitle
              : data?.chStuffName
              ? data?.chStuffName
              : data?.chTitle}
          </span>
          <IconButton
            onClick={() => {
              if (id) {
                navigate(`/sell/preview/${id}#D_${data?.guidRecNo}`);
              } else {
                navigate(`/sell/preview/create#D_${data?.guidRecNo}`);
              }
            }}
          >
            <RemoveRedEyeIcon color="primary" />
          </IconButton>
        </div>
      ) : (
        <span className="text-sm font-bold">
          {data?.chSellerStuffSendName
            ? data?.chSellerStuffSendName
            : data?.chSellerStuffTitle
            ? data?.chSellerStuffTitle
            : data?.chStuffName
            ? data?.chStuffName
            : data?.chTitle}
        </span>
      )}

      <div className="w-full grid grid-cols-2 gap-3 px-0">
        {" "}
        {noEdit ? (
          <>
            <div className="border border-solid border-[#bbcfec] flex flex-col justify-center items-center rounded-md py-2">
              <h3 className="text-xs border-b mb-1 pb-1 font-semibold ">
                تعداد/مقدار
              </h3>
              <span className="text-sm font-bold">
                {data?.flAmount} {data?.chMeasurementUnitName}
              </span>
            </div>
          </>
        ) : (
          <></>
        )}
        <div className="border border-solid border-[#bbcfec] flex flex-col justify-center items-center rounded-md py-2">
          <h3 className="text-xs border-b mb-1 pb-1 font-semibold ">
            مبلغ واحد
          </h3>
          <span className="text-sm font-bold">
            {type === "CurrSale"
              ? Number(data?.moCurrencyExchangePrice)?.toLocaleString("en-US")
              : data?.moUnitPrice !== null
              ? Number(data?.moUnitPrice)?.toLocaleString("en-US")
              : "-"}
          </span>
        </div>
        {data?.moDiscount ? (
          <div className="border border-solid border-[#bbcfec] flex flex-col justify-center items-center rounded-md py-2">
            <h3 className="text-xs border-b mb-1 pb-1 font-semibold ">تخفیف</h3>
            <span className="text-sm font-bold">
              {data?.moDiscount !== null
                ? Number(data?.moDiscount)?.toLocaleString("en-US")
                : "-"}
            </span>
          </div>
        ) : (
          <></>
        )}
        {data?.flValueAddedPercent ? (
          <div className="border border-solid border-[#bbcfec] flex flex-col justify-center items-center rounded-md py-2">
            <h3 className="text-xs border-b mb-1 pb-1 font-semibold ">
              مالیات
            </h3>
            <span className="text-sm font-bold">
              {data?.flValueAddedPercent !== null
                ? data?.flValueAddedPercent
                : "-"}{" "}
              %
            </span>
          </div>
        ) : (
          <></>
        )}{" "}
        {noEdit ? (
          <>
            {data?.moConsProfitWorkPrice ? (
              <div className="border border-solid border-[#bbcfec] flex flex-col justify-center items-center rounded-md py-2">
                <h3 className="text-[10px] text-center border-b mb-1 pb-1 font-semibold ">
                  جمع کل اجرت، حق العمل و سود
                </h3>
                <span className="text-sm font-bold">
                  {data?.moConsProfitWorkPrice?.toLocaleString("en-US")}
                </span>
              </div>
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}{" "}
        {noEdit ? (
          <>
            {" "}
            <div className="border border-solid border-[#bbcfec] flex flex-col justify-center items-center rounded-md py-2">
              <h3 className="text-xs border-b mb-1 pb-1 font-semibold ">
                جمع ردیف
              </h3>
              <span className="text-sm font-bold">
                {data.moTotalStuffPrice?.toLocaleString("en-US")}
              </span>
            </div>
          </>
        ) : (
          <>
            {" "}
            {calcData && !isNaN(calcData) ? (
              <div className="border border-solid border-[#bbcfec] flex flex-col justify-center items-center rounded-md py-2">
                <h3 className="text-xs border-b mb-1 pb-1 font-semibold ">
                  قیمت
                </h3>
                <span className="text-sm font-bold">
                  {isNaN(calcData) ? "" : calcData?.toLocaleString("en-US")}
                </span>
              </div>
            ) : (
              <></>
            )}
          </>
        )}
      </div>
      {type === "CurrSale" ? (
        <>
          <Modal
            open={open}
            onClose={() => {
              if (id) {
                navigate(`/sell/${noEdit ? "preview" : "invoice"}/${id}`);
              } else {
                navigate(`/sell/${noEdit ? "preview" : "invoice"}/create`);
              }
              setChangedData(data);
            }}
          >
            <CurrencyModal
              data={data}
              changedData={changedData}
              setChangedData={setChangedData}
              setData={setData}
              currencyOption={currencyOption}
              defaults={defaults}
              noEdit={noEdit}
            />
          </Modal>
          <Modal
            open={open2}
            onClose={() => {
              if (id) {
                navigate(`/sell/${noEdit ? "preview" : "invoice"}/${id}`);
              } else {
                navigate(`/sell/${noEdit ? "preview" : "invoice"}/create`);
              }
            }}
          >
            <CurrencyModalPreview
              currencyOption={currencyOption}
              defaults={defaults}
              noEdit={noEdit}
              data={data}
            />
          </Modal>
        </>
      ) : type === "Jewelry" ? (
        <>
          <Modal
            open={open}
            onClose={() => {
              if (id) {
                navigate(`/sell/${noEdit ? "preview" : "invoice"}/${id}`);
              } else {
                navigate(`/sell/${noEdit ? "preview" : "invoice"}/create`);
              }
              setChangedData(data);
            }}
          >
            <GoldModal
              data={data}
              changedData={changedData}
              setChangedData={setChangedData}
              setData={setData}
              noEdit={noEdit}
              defaults={defaults}
              setHojrat={setHojrat}
              hojrat={hojrat}
              setProfit={setProfit}
              profit={profit}
            />
          </Modal>
          <Modal
            open={open2}
            onClose={() => {
              if (id) {
                navigate(`/sell/${noEdit ? "preview" : "invoice"}/${id}`);
              } else {
                navigate(`/sell/${noEdit ? "preview" : "invoice"}/create`);
              }
            }}
          >
            <GoldReview
              currencyOption={currencyOption}
              defaults={defaults}
              data={data}
              noEdit={noEdit}
            />
          </Modal>
        </>
      ) : (
        <>
          {" "}
          <Modal
            open={open}
            onClose={() => {
              if (id) {
                navigate(`/sell/${noEdit ? "preview" : "invoice"}/${id}`);
              } else {
                navigate(`/sell/${noEdit ? "preview" : "invoice"}/create`);
              }
              setChangedData(data);
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: { md: "90%", xs: "90%" },
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 2,
                borderRadius: 2,
                overflow: "auto",
                maxHeight: "95%",
                maxWidth: "400px",
              }}
            >
              <div className="flex flex-col gap-4">
                <div className="border-b border-solid border-[#bbcfec] pb-4">
                  <h2 className="text-sm font-bold">{data?.chTitle}</h2>
                </div>
                <TextInput
                  label="عنوان ارسالی"
                  onChange={(e) =>
                    setChangedData({ ...changedData, chSellerStuffSendName: e })
                  }
                  value={changedData.chSellerStuffSendName}
                />
                <TextInput
                  label=" تعداد"
                  onChange={(e) =>
                    setChangedData({ ...changedData, flAmount: Number(e) })
                  }
                  value={changedData.flAmount}
                  number
                />
                <TextInput
                  label=" مبلغ واحد"
                  onChange={(e) =>
                    setChangedData({ ...changedData, moUnitPrice: e })
                  }
                  value={changedData.moUnitPrice || ""}
                  price
                  number
                />
                <TextInput
                  label=" تخفیف"
                  onChange={(e) =>
                    setChangedData({ ...changedData, moDiscount: e })
                  }
                  value={changedData.moDiscount}
                  number
                  allowZero
                  price
                />{" "}
                {type !== "Export" && (
                  <TextInput
                    label="  مالیات بر ارزش افزوده "
                    onChange={(e) =>
                      setChangedData({ ...changedData, flValueAddedPercent: e })
                    }
                    value={changedData.flValueAddedPercent}
                    number
                    allowZero
                    price
                    priceLabel="%"
                  />
                )}
              </div>
              <div className="flex col-span-2 justify-between items-center mt-5">
                <Button
                  disabled={!changedData?.moUnitPrice || !changedData?.flAmount}
                  onClick={() => {
                    setData(changedData);
                    if (id) {
                      navigate(`/sell/${noEdit ? "preview" : "invoice"}/${id}`);
                    } else {
                      navigate(
                        `/sell/${noEdit ? "preview" : "invoice"}/create`
                      );
                    }
                  }}
                  sx={{ width: "8rem" }}
                  variant="contained"
                  color="primary"
                >
                  <> ویرایش</>
                </Button>{" "}
                <Button
                  onClick={() => {
                    if (id) {
                      navigate(`/sell/${noEdit ? "preview" : "invoice"}/${id}`);
                    } else {
                      navigate(
                        `/sell/${noEdit ? "preview" : "invoice"}/create`
                      );
                    }
                    setChangedData(data);
                  }}
                  sx={{ width: "8rem", background: "#ccc" }}
                  variant="contained"
                  color="inherit"
                >
                  انصرف
                </Button>
              </div>
            </Box>
          </Modal>
          <Modal
            open={open2}
            onClose={() => {
              if (id) {
                navigate(`/sell/${noEdit ? "preview" : "invoice"}/${id}`);
              } else {
                navigate(`/sell/${noEdit ? "preview" : "invoice"}/create`);
              }
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: { md: "90%", xs: "90%" },
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 2,
                borderRadius: 2,
                overflow: "auto",
                maxHeight: "95%",
                maxWidth: "400px",
              }}
            >
              <div className="flex flex-col gap-4">
                <div className="border-b border-solid border-[#bbcfec] pb-4">
                  <h2 className="text-sm font-bold">{data?.chTitle}</h2>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-sm ">عنوان ارسالی : </span>
                  <h2 className="text-sm font-bold">
                    {data?.chSellerStuffSendName}
                  </h2>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-sm ">تعداد : </span>
                  <h2 className="text-sm font-bold">
                    {data?.flAmount} {data?.chMeasurementUnitName}
                  </h2>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-sm ">مبلغ واحد : </span>
                  <h2 className="text-sm font-bold">
                    {data?.moUnitPrice?.toLocaleString("en-US")} ریال{" "}
                  </h2>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-sm ">مبلغ تخفیف : </span>
                  <h2 className="text-sm font-bold">
                    {data?.moDiscount?.toLocaleString("en-US")} ریال{" "}
                  </h2>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-sm ">نرخ ارزش افزوده :</span>
                  <h2 className="text-sm font-bold">
                    {data?.flValueAddedPercent?.toLocaleString("en-US")} %{" "}
                  </h2>
                </div>
              </div>
              <div className="flex col-span-2 justify-center items-center mt-5">
                <Button
                  onClick={() => {
                    if (id) {
                      navigate(`/sell/${noEdit ? "preview" : "invoice"}/${id}`);
                    } else {
                      navigate(
                        `/sell/${noEdit ? "preview" : "invoice"}/create`
                      );
                    }
                    setChangedData(data);
                  }}
                  sx={{ width: "8rem", background: "#ccc" }}
                  variant="contained"
                  color="inherit"
                >
                  بازگشت
                </Button>
              </div>
            </Box>
          </Modal>
        </>
      )}
    </div>
  );
};

export default ProductCart;
